import { type ReactNode } from "react";

const TBody = ({ children }: { children: ReactNode }) => {
  return <tbody>{children}</tbody>;
};

export default TBody;
